<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/Text/pppstrangers005#toc">Dedication</a></p>
<p class="pf"><i class="calibre3">For all the Americans who saw those first tall ships crest on the horizon…</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-strangers004.vue?a0f50e74